"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatusContext = exports.INITIAL_STATE = exports.DEFAULT_MODAL_CONFIG = void 0;
const react_1 = require("react");
/**
 * Default modal configuration
 */
exports.DEFAULT_MODAL_CONFIG = {
    title: 'Processing Operation',
    description: undefined,
    autoClose: false,
    autoCloseDelay: 2000,
    closeable: false,
    showDetails: false,
    onComplete: undefined,
    onError: undefined,
    showItemCount: true,
    customCompleteMessage: undefined,
    customFailedMessage: undefined,
    customActiveMessage: undefined,
};
/**
 * Initial job status context state
 */
exports.INITIAL_STATE = {
    isModalOpen: false,
    currentJobId: null,
    modalConfig: exports.DEFAULT_MODAL_CONFIG,
    lastJobResult: null,
    lastError: null,
};
/**
 * Job status context for global modal management
 *
 * This context provides a global way to manage JobStatusModal instances
 * that persist across component unmounts and modal-to-modal transitions.
 */
exports.JobStatusContext = (0, react_1.createContext)(undefined);
exports.JobStatusContext.displayName = 'JobStatusContext';
